module.exports = __webpack_public_path__ + "media/images/photo/photo-og-image-ece84f4f21d949ffaa488b34c2e986ef.jpg";